import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../utils/supabase';
import { Footer } from '../component/Footer';
import { Header } from '../component/Header';

const PrivacyPolicy = () => {
  const [email, setEmail] = useState('');
  const [userId, setUserId] = useState('');
  const [status, setStatus] = useState({ type: '', message: '' });
  const [loading, setLoading] = useState(false);

  const handleDeleteRequest = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: '', message: '' });

    try {
      const { error } = await supabase
        .from('account_deletion_requests')
        .insert([{ 
          email: email, 
          userId: userId,
          // requested_at: new Date().toISOString() 
        }]);

      if (error) throw error;

      setStatus({ type: 'success', message: `Request submitted. We will contact you at ${email}.` });
      setEmail('');
      setUserId('');
    } catch (error) {
      setStatus({ type: 'error', message: error.message || 'Failed to submit request.' });
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="min-h-screen bg-[#FFFDE1] font-sans text-zinc-900">
      {/* Navigation */}
    <Header/>

      <div className="max-w-3xl mx-auto px-6 py-16">
        <header className="mb-12">
          <div className="inline-block px-3 py-1 bg-[#ef3a5d] text-white text-[10px] font-bold uppercase tracking-widest mb-4">
            Security / Privacy
          </div>
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight uppercase leading-none mb-4">
            Privacy Policy
          </h1>
          <p className="text-zinc-500 font-mono text-xs uppercase tracking-widest">
            Effective Date: Jan 01, 2026
          </p>
        </header>

        <main className="space-y-10">
          <section>
            <h2 className="text-xl font-black uppercase tracking-tight flex items-center gap-2">
              <span className="text-[#ef3a5d]">01.</span> Data Collection
            </h2>
            <div className="h-1 w-10 bg-zinc-900 mb-4"></div>
            <p className="text-zinc-600 leading-relaxed">
              We collect minimal information required to track your rewards. This includes your <span className="font-bold">Name</span> (not username) and contact details provided at partner restaurants, along with your transaction history to calculate your Savings Pool.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black uppercase tracking-tight flex items-center gap-2">
              <span className="text-[#ef3a5d]">02.</span> How We Use Data
            </h2>
            <div className="h-1 w-10 bg-zinc-900 mb-4"></div>
            <p className="text-zinc-600 leading-relaxed mb-4">
              Your data is used strictly to:
            </p>
            <ul className="space-y-2 text-zinc-600 italic border-l-2 border-zinc-200 pl-4 text-sm">
              <li>• Calculate and verify your "Savings Pool" milestones.</li>
              <li>• Send automated alerts when a reward is ready for redemption.</li>
              <li>• Provide partner restaurants with anonymized dining trends.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-black uppercase tracking-tight flex items-center gap-2">
              <span className="text-[#ef3a5d]">03.</span> Sharing & Security
            </h2>
            <div className="h-1 w-10 bg-zinc-900 mb-4"></div>
            <p className="text-zinc-600 leading-relaxed">
              We <span className="underline decoration-[#ef3a5d] decoration-2">never sell your data</span>. Your check-in history is shared only with the specific restaurant chain you are visiting to ensure your bill is calculated correctly. We use industry-standard encryption to keep your loyalty data safe.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black uppercase tracking-tight flex items-center gap-2">
              <span className="text-[#ef3a5d]">04.</span> Your Rights
            </h2>
            <div className="h-1 w-10 bg-zinc-900 mb-4"></div>
            <p className="text-zinc-600 leading-relaxed">
              You own your data. You can request a full export of your dining history or ask for your account to be deleted at any time by contacting our privacy team.
            </p>
          </section>
<section className="mt-24 border-t-4 border-zinc-900 pt-16">
          <div className="inline-block px-3 py-1 bg-black text-white text-[10px] font-bold uppercase tracking-widest mb-4">
            Account Management
          </div>
          <h2 className="text-3xl font-black uppercase tracking-tight mb-4">
            Delete My Account
          </h2>
          <p className="text-zinc-600 mb-8 leading-relaxed">
            Ready to leave? Enter your details below. Once submitted, your <span className="font-bold">name</span> and restaurants history will be purged from our active records.
          </p>

          <form onSubmit={handleDeleteRequest} className="space-y-4 max-w-md">
            <div>
              <label className="block text-[10px] font-bold uppercase tracking-widest text-zinc-400 mb-1">Email Address</label>
              <input 
                required
                type="email" 
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="email@example.com"
                className="w-full bg-white border-2 border-zinc-200 p-3 outline-none focus:border-[#ef3a5d] font-mono text-sm transition-colors"
              />
            </div>
            <div>
              <label className="block text-[10px] font-bold uppercase tracking-widest text-zinc-400 mb-1">User ID</label>
              <input 
                required
                type="text" 
                value={userId}
                onChange={(e) => setUserId(e.target.value)}
                placeholder="Find this in app settings"
                className="w-full bg-white border-2 border-zinc-200 p-3 outline-none focus:border-[#ef3a5d] font-mono text-sm transition-colors"
              />
            </div>
            
            <button 
              type="submit"
              disabled={loading}
              className={`w-full py-4 text-[10px] font-black uppercase tracking-[0.2em] transition-all 
                ${loading ? 'bg-zinc-300' : 'bg-[#ef3a5d] hover:bg-black text-white'}`}
            >
              {loading ? 'Processing...' : 'Confirm Deletion Request'}
            </button>

            {status.message && (
              <div className={`p-4 text-xs font-bold uppercase tracking-tight ${status.type === 'success' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                {status.message}
              </div>
            )}
          </form>
        </section>
          {/* Contact Box */}
          <div className="bg-zinc-100 border-2 border-zinc-200 p-8 rounded-2xl mt-16">
            <h3 className="font-bold uppercase tracking-tighter text-lg mb-2">Data Protection Office</h3>
            <p className="text-zinc-500 text-sm mb-6 leading-relaxed">
              For any privacy-related concerns or data requests, please reach out via the channels below.
            </p>
            <div className="space-y-1">
              <p className="text-xs font-mono uppercase font-bold text-zinc-400">Email</p>
              <a href="mailto:info@discownty.com" className="text-zinc-900 font-bold hover:text-[#ef3a5d] transition-colors">
                info@discownty.com
              </a>
            </div>
            
          </div>
          
        </main>
      </div>

      {/* Footer */}
     <Footer/>
    </div>
  );
};

export default PrivacyPolicy;
